import React from 'react';
import './CourseOverview.css';
import overviewLeftImage from '../../../assets/Gallery/overview-left-image.jpg'
import overviewRightImage from '../../../assets/Course Images/hotelManagement.png'

function CourseOverview() {
    return (
        <div className='courseoverview-outer'>
            <div className="courseoverview-inner">
                <h2 className="header-text">Course Overview</h2>
                <div className="overview-div">
                    <div className="overview-left">
                        <div className="overview-left-image">
                            <img src={overviewLeftImage} alt="" />
                        </div>
                        <div className="overview-left-bottom-outer">
                            <div className="overview-left-bottom">
                                <div className="months">
                                    <h3 className="header-text">3-6</h3>
                                    <p className="letter-text">Months</p>
                                </div>
                                <p className="letter-text">
                                    You can even plan to do a <span style={{fontWeight: '900'}}>certification course</span>with LIMS within just 6 months. It can be even less based on your performance.
                                </p>
                                <div className="overview-line"></div>
                            </div>
                            <div className="overview-right-bottom">
                                <div className="months">
                                    <h3 className="header-text">12th</h3>
                                    <p className="letter-text">Pass</p>
                                </div>
                                <p className="letter-text">
                                You can join as a management student  at LIMS if you are 10th pass at least and less than 27 years old. If you are ready.
                                </p>
                                <div className="overview-line"></div>
                            </div>
                        </div>
                    </div>
                    <div className="overview-right">
                        <div className="overview-right-bottom" id='overview-right-top'>
                            <p className="letter-text">Course Details</p>
                            <h3 className="letter-text" id='course-subject'>Diploma in Hotel Management</h3>
                            <p className="letter-text">
                                The Duration of this course is about 12-18 months and it may depend on your current skills. It can be less also.
                            </p>
                            <div className="overview-line"></div>
                        </div>
                        <div className="overview-left-image">
                            <img src={overviewRightImage} alt="" />
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default CourseOverview
